const BASE = "/api/admin/allowed-emails";

export interface AllowedEmailDto {
	id: string;
	email: string;
	note: string | null;
	usedAt: string | null;
	usedById: string | null;
	createdAt: string;
	user: { id: string; role: string | null; emailVerified: boolean } | null;
}

export interface AllowedEmailPage {
	data: AllowedEmailDto[];
	total: number;
	page: number;
	limit: number;
}

async function request<T>(url: string, init?: RequestInit): Promise<T> {
	const res = await fetch(url, {
		...init,
		headers: { "Content-Type": "application/json", ...init?.headers },
	});
	if (!res.ok) {
		const body = (await res.json().catch(() => ({}))) as { error?: string };
		throw new Error(body.error ?? `HTTP ${res.status}`);
	}
	return (await res.json()) as T;
}

const call = <T>(path: string, init?: RequestInit) =>
	request<T>(`${BASE}${path}`, init);

/** Ambil satu halaman daftar allowlist. */
export const fetchAllowedEmails = (page: number, limit: number) =>
	call<AllowedEmailPage>(`?page=${page}&limit=${limit}`);

/** Tambah email ke allowlist (server menormalkan & memvalidasi). */
export const addAllowedEmail = (email: string, note: string) =>
	call<{ data: AllowedEmailDto }>("", {
		method: "POST",
		body: JSON.stringify({ email, note: note || undefined }),
	});

/** Hapus satu entri allowlist. */
export const removeAllowedEmail = (id: string) =>
	call<{ success: boolean }>(`/${id}`, { method: "DELETE" });

/** Ubah role user yang memakai entri (endpoint manajemen pengguna). */
export const updateUserRole = (id: string, role: string) =>
	request<{ user: { id: string; role: string | null } }>(
		"/api/admin/users/update-role",
		{ method: "POST", body: JSON.stringify({ id, role }) },
	);

/** Atur status verifikasi user yang memakai entri (endpoint manajemen pengguna). */
export const setUserVerified = (id: string, verified: boolean) =>
	request<{ success: boolean }>("/api/admin/users/verify", {
		method: "POST",
		body: JSON.stringify({ id, verified }),
	});
